import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Inject, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { JobsService } from '../jobs.service';
import { ConfirmationService, LazyLoadEvent, LazyLoadMeta } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { UploadDialogComponent } from '../../photos/upload-dialog/upload-dialog.component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Loading } from 'notiflix';
import { ISqlJob} from '../sql-job.interface';
import { Clipboard } from '@angular/cdk/clipboard';
import { InspectionFormDialogComponent } from '../../forms/inspection-form-dialog/inspection-form-dialog.component';
import { AppService } from '../../app.service';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ToastModule } from 'primeng/toast';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { DatePipe } from '@angular/common';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { UsersService } from '../../users/users.service';
import { UserRole } from '../../users/roles.enum';
import { TagModule } from 'primeng/tag';
import { NotesDialogComponent } from '../../notes/notes-dialog/notes-dalog.component';
import { DateTime } from 'luxon';
import { AuthService } from '../../auth/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom, Subscription } from 'rxjs';
import { Overlay } from 'primeng/overlay';
import { JOB_STATUS } from '../job-status.enum';
import { BadgeModule } from 'primeng/badge';
import { NotesService } from '../../notes/notes.service';
import { DropdownModule } from 'primeng/dropdown';
import { InputGroupModule } from 'primeng/inputgroup';
import { PhoneNumberPipe } from '../../pipes/phone-number.pipe';
import { InspectionComponent } from '../../inspection/inspection.component';
import { environment } from '../../../environments/environment';
import { PdfFormComponent } from '../../pdf-form/pdf-form.component'
import { AuthCommunicationService } from 'src/app/auth/auth.communication.service';
import { isValidEmail as validateEmail } from '../../shared/utils/email-validator';
import { EmailValidatorPipe } from '../../shared/pipes/email-validator.pipe';
import { InspectionFormService } from '../../forms/inspection-form/inspection-form.service';
import { LayersLoadedEvent } from 'ngx-extended-pdf-viewer';
import { Table } from 'primeng/table';
import { each, forEach } from 'lodash';
type ButtonVariant = "success" | "secondary" | "info" | "warning" | "danger" | "contrast" | undefined;

// Define jobsFilterTypes to match the structure used in loadJobsLazy 
// TODO this should be imported from csi-sitecheck-types
export interface FilterMetadata {
    value?: any;
    matchMode?: string;
    operator?: string;
}

export interface jobsFilterTypes {
    sortField?: string | string[] | null | undefined;
    sortOrder?: number | undefined | null;
    filters?: {
        [s: string]: FilterMetadata | FilterMetadata[] | undefined;
    };
    globalFilter?: string | string[] | undefined | null;
}
//TODO END


const DEFAULT_ROWS_PER_PAGE = 100; 

@Component({
  standalone: true,
  selector: 'app-jobs-manager',
  imports: [
    ScrollPanelModule,
    ToastModule,
    TableModule,
    ConfirmDialogModule,
    CommonModule,
    TooltipModule,
    InputTextModule,
    ClipboardModule,
    CalendarModule,
    OverlayPanelModule,
    FormsModule,
    TagModule,
    BadgeModule,
    DropdownModule,
    InputGroupModule,
    PhoneNumberPipe,
    EmailValidatorPipe,
  ],
  providers: [DialogService, ConfirmationService, InspectionFormService],
  templateUrl: './jobs-manager.component.html',
  styleUrls: ['./jobs-manager.component.scss'],
  // encapsulation: ViewEncapsulation.None
})

export class JobsManagerComponent implements OnInit, OnDestroy {
  jobs: ISqlJob[] = [];
  currentUser: any;
  currentUserRoleName: string = '';
  currentUserPrimaryRole: UserRole = 0;
  datePipe: DatePipe = new DatePipe('en-US');
  scheduledDate: Date | null = null;
  UserRole = UserRole;
  statusTotals: { [status: string]: number } = {};
  dateTime = DateTime;
  JOB_STATUS = JOB_STATUS;
  selectedJobStatusId: number = 0;
  isShowDelivered: boolean = false;
  specificJobStatusShowing?: JOB_STATUS = undefined;
  env = environment;
  ref: DynamicDialogRef | undefined; 
  private dialogRefs: DynamicDialogRef[] = []; // keep track of all dialog refs
  
  rowsPerPage: number = DEFAULT_ROWS_PER_PAGE;
  totalRecords: number = 0;
  private loadedChunks = new Set<number>();
  private isLoading = false;
  private previousFiltersState: string = ''
  private currentFilters: jobsFilterTypes = {}
  globalSearchValue: string = '';

  calculateDueDate = this.jobsService.calculateDueDate;

  private logoutSubscription!: Subscription;
  private lastLazyEvent: TableLazyLoadEvent | undefined;

  @ViewChild('dt') dataTable!: Table;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private jobsService: JobsService,
    private confirmationService: ConfirmationService,
    private dialogService: DialogService,
    private messageService: MessageService,
    private clipboard: Clipboard,
    private app: AppService,
    private users: UsersService,
    private authService: AuthService,
    private http: HttpClient,
    private cd: ChangeDetectorRef,
    private notesService: NotesService,
    private authCommunicationService: AuthCommunicationService,
    private inspectionFormService: InspectionFormService
  ) {
      this.breadcrumbService.setItems([
        {label: 'Jobs Manager', routerLink: ['/']}
      ]);
    }

  ngOnInit(): void {
    this.logoutSubscription = this.authCommunicationService.logout$.subscribe(() => {
      this.closeAllModals();
    });
    this.getJobs();
  }


  ngOnDestroy() {
    if (this.logoutSubscription) {
      this.logoutSubscription.unsubscribe();
    }
    this.closeAllModals();
  }

  closeAllModals() {
    this.dialogRefs.forEach(ref => ref.close());
    this.dialogRefs = [];
  }

  sendLinkEmail(job: ISqlJob, event: any): void {
    if (!event.shiftKey) {
      this.confirmationService.confirm({
        key: 'jobsManagerConfirmDialog',
        message: `Are you sure you want to send the link for Job# ${job.scJobId}?`,
        accept: () => {
          console.log('Sending email to assigned rep...');
          this.jobsService.sendLinkEmail(job.jobId, job.scJobId)
            .then(res => {
              job.trackingStatus = res.status;
              this.messageService.add({severity: 'success', summary: 'Email sent to inspector', detail: job.scRepEmail});
            });
        }
      });
    } else {
      this.jobsService.getInspectionFormLink(job.jobId, job.scJobId)
        .then(data => {
          if (data) {
            if ( this.clipboard.copy(data.link.toString()) ) {
              this.messageService.add({
                severity: 'success',
                summary: 'Link copied',
                detail: 'You can now paste the link anywhere you like.'
              });
            } else {
              this.messageService.add({
                severity: 'warning',
                summary: 'Link Logged to Console',
                detail: 'Check the developer console for the link.'
              });
            }
            console.log(data.link);
          }
        });
    }

  }

  deliverInspection(job: ISqlJob): void {
    this.confirmationService.confirm({
      key: 'jobsManagerConfirmDialog',
      message: `Are you sure you want to deliver job# ${job.scJobId}?`,
      accept: async () => {
        Loading.standard('Processing job for delivery...');
        this.jobsService.deliverJob(job.scJobId)
          .then(async res => {
            Loading.remove();
            if (res.success) {
              job.scJobStatusId = JOB_STATUS.DELIVERED;
              this.statusTotals = await this.getDistinctStatusesAndTotals();
              this.messageService.add({
                severity: 'success',
                summary: 'Job Delivered',
                detail: 'The job has been delivered and is ready for customer review.'
              });
            } else {
              this.messageService.add({
                severity: 'info',
                summary: 'Nothing to Deliver',
                detail: 'There was nothing to deliver for this job.'
              });
            }
          })
          .catch(err => {
            console.log(`Unable to deliver job.\n${err}`);
            Loading.remove();
            this.messageService.add({
              severity: 'error', summary: 'Unable to Deliver Job',
              detail: 'Unable to deliver job to legacy system.'
            });
          })
          .finally(() => {
            Loading.remove();
          });
      }
    });
  }

 async openInspectionForm(job: ISqlJob, event: any): Promise<void> {
    if (!event?.shiftKey) {
      const updatedJob = await this.getJob(job.scJobId); //force load the mongodb part
      console.log('openinspectionform, updatedjob', updatedJob);
      const ref = this.dialogService.open(InspectionFormDialogComponent, {
        modal: true,
        data: {
          job: updatedJob,
        },
        header: `Inspection Form for Job# ${job.scJobId}`,
        width: '90vw',
        height: '90vh',
        showHeader: true,
        focusOnShow: true,
        closeOnEscape: false,
        closable: true,
        // styleClass: 'inspection-form-dialog',
        contentStyle: { 'height': '100%', 'overflow-y': 'hidden !important' },
      });
  
      ref.onClose.subscribe(() => {
        this.getJob(job.scJobId);
      });
      
      this.dialogRefs.push(ref); 
    } else {
      
    }
  }

  async openInspection(job: ISqlJob, event: any): Promise<void>  {
    if (!event?.shiftKey) {
      const updatedJob = await this.getJob(job.scJobId); //force load the mongodb part
      console.log('openinspection, updatedjob', updatedJob);
      const ref = this.dialogService.open(InspectionComponent, {
        data: {
         job:updatedJob
        },
        header: `Inspection Photos / Form for Job# ${job.scJobId}`,
        width: '90vw',
        height: '90vh',
        showHeader: true,
        focusOnShow: true,
        closeOnEscape: false,
        contentStyle: { 'height': '100%', 'overflow-y': 'hidden !important' },
        closable: true,
      });
  
      ref.onClose.subscribe(() => {
        this.getJob(job.scJobId);
      });

      this.dialogRefs.push(ref); 
    } else {
      
    }
  }


  async openPhotoUpload(job: ISqlJob, event: any): Promise<void> {
    if (!event?.shiftKey) {
      const updatedJob = await this.getJob(job.scJobId); //force load the mongodb part
      const ref = this.dialogService.open(UploadDialogComponent, {
        data: {
          job:updatedJob
        },
        header: `Upload Photos for Job# ${job.scJobId}`,
        width: '85vw',
        height: '85vh',
        showHeader: true,
        
        closeOnEscape: false,
      });
  
      ref.onClose.subscribe(() => {
        // if (modifiedForm) {
        //   console.log(modifiedForm);
        //   form = modifiedForm;
        //   this.messageService.add({severity: 'info', summary: 'Inspection form saved', detail: modifiedForm.name});
        // }
      });

      this.dialogRefs.push(ref);
    } else {

    }
  }

  openNotesDialog(job: ISqlJob): void {
    const ref = this.dialogService.open(NotesDialogComponent, {
      data: {
        job,
        currentUser: this.currentUser,
      },
      header: `Job ${job.scJobId} / Notes for ${job.scInsuredName.toUpperCase()}`,
      width: '80vw',
      height: '80vh',
      showHeader: true,
      closeOnEscape: false,
    });

    ref.onClose.subscribe(() => {

    });
    
    this.dialogRefs.push(ref);
  }

  openCalendar(job: ISqlJob): void {
    // const ref = this.dialogService.open(UploadDialogComponent, {
    //   data: {
    //     job
    //   },
    //   header: `Schedule Inspection for Job# ${job.scJobId}`,
    //   width: '85%',
    //   showHeader: true,
    //   closeOnEscape: false,
    // });

    // ref.onClose.subscribe(() => {

    // });
  }

  getDueDateStyle(requestDate: string, userRole: UserRole): ButtonVariant {
    const dueDate = DateTime.fromISO(requestDate).plus({ days: userRole === UserRole.REP ? 14 : 30 });
    const now = DateTime.local();
    const diff = dueDate.diff(now, 'days').days;
    if (diff <= 0) {
      return 'danger';
    } else if (diff <= 5) {
      return 'warning';
    } else {
      return 'success';
    }
  }
  
  // This function is used to get the status totals from the jobsCount array
  getStatusesFromQueryFilter(jobsCount: any): { [status: string]: number } {
    let grandTotal:number=0;
    const statusTotals: { [status: string]: number } = {};
    for (const element of jobsCount) {
      const status = element.scJobStatus;
      statusTotals[status]=element.totalByStatus;
      grandTotal+=element.totalByStatus;
      }
    this.totalRecords = grandTotal; 
    return statusTotals;
  }

   async getDistinctStatusesAndTotals(): Promise<{ [status: string]: number; }> {
      const response =  await this.jobsService.getJobsStatusCount(
        this.currentUser,
        this.currentFilters,
        this.specificJobStatusShowing 
      );

      return (response.data && response.data.length > 0) ? this.getStatusesFromQueryFilter(response.data) : {};
  }

  async openPdf(job: ISqlJob, event: any): Promise<void> {
    Loading.dots('Opening PDF Form...');
    let blob: Blob | null;

    // const flatten = (this.currentUserPrimaryRole === UserRole.REP || event?.shiftKey) ? 'flatten=true&' : '';
    const flatten = 'flatten=true&';
    const cacheBuster = `cb=${Date.now()}`;
    const pdfRenderUrl = `${this.env.baseApiUrl}/jobs/render-pdf/${job.scJobId}?${flatten}${cacheBuster}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/pdf',
      'Authorization': `Bearer ${this.authService.token}`
    });
    try {
      blob = await firstValueFrom( this.http.get(pdfRenderUrl, { 
        headers: headers,
        responseType: 'blob', 
      }));
      if (!blob) {
        throw new Error('Unable to open the PDF form.');
      }
      const url = window.URL.createObjectURL(blob);
      blob = null;
      if (this.currentUserPrimaryRole === UserRole.REP || event?.shiftKey || job.scJobStatusId === JOB_STATUS.DELIVERED || job.scJobStatusId === JOB_STATUS.READY_TO_DELIVER) {
        window.open(url, '_blank');
        return;
      }

      this.ref = this.dialogService.open(PdfFormComponent, { 
        data: { 
          url: url,
          jobId: job.jobId,
          job: job
        },
        header: 'PDF Form Review',
        width: '90vw',
        height: '90vh',
        // closable: true,
        // closeOnEscape: true,
        modal: true,
        style: { 'height': '100%', 'overflow-y': 'hidden !important' },
      });
  
      this.ref.onClose.subscribe(async (response) => {
        this.statusTotals = await this.getDistinctStatusesAndTotals();
      });
        
      this.dialogRefs.push(this.ref);
      this.ref = undefined;
      
    } catch(err: any) {
        console.log(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Unable to Open the PDF Form',
          detail: err.message ? err.message : 'An unknown error occurred.'
        });
    } finally {
      blob = null;
      Loading.remove();
    }
  }

  async updateScheduledDate(job: ISqlJob, overlaypanel: any): Promise<void> {
    if (!this.scheduledDate) {
      return;
    }
    job.scScheduledDate = this.scheduledDate.toISOString();
    const resp = await this.jobsService.updateScheduledDate(job.scJobId, job.scScheduledDate);
    console.log(job.scScheduledDate);
    this.scheduledDate = null;
    overlaypanel.toggle(false);
    this.getJob(job.scJobId);
  }

  showDatePanel(event: Event, job: ISqlJob): void {
    this.scheduledDate = new Date(job.scScheduledDate);
    console.log(this.scheduledDate);
  }

  minimumScheduledDate(): Date {
    const minDate =  this.dateTime.local().toJSDate();
    console.log(minDate);
    return minDate;
  }

  maximumScheduledDate(): Date {
    const maxDate = this.dateTime.local().plus({ days: 60 }).toJSDate();
    console.log(maxDate);
    return maxDate;
  }

  openTimeSheet(job: ISqlJob, event: any) {
    window.open(`https://portal.csina.com/field/billingInfo.aspx?src=SC&id=${job.scExternalJobId}`, '_blank');
  }

  async submitToQc(job: ISqlJob): Promise<void> {
    const confirmed = await this.inspectionFormService.confirmAction(
      `Are you sure you want to submit job ${job.scJobId} for QC review?`
    );

    if (!confirmed) {
      return;
    }

    try {
      const updatedJob = await this.inspectionFormService.submitToQc(job.jobId);
      await this.getJob(job.scJobId);
    } catch (error) {
      // Error handling is done in the service
    }
  }

 
  async resetFilters(dt: Table): Promise<void> {

    //dt.reset(); do not use this it has to be done manually
    this.globalSearchValue = '';

    if (dt.filters) {
      Object.keys(dt.filters).forEach(key => {
        const filter = dt.filters[key];
        if (Array.isArray(filter)) {
          filter.forEach(f => {
            if (f && typeof f === 'object' && 'value' in f) {
              (f as FilterMetadata).value = null;
            }
          });
        } else if (filter && typeof filter === 'object' && 'value' in filter) {
          (filter as FilterMetadata).value = null;
        }
      });
    }

    dt.sortField = 'scJobId';
    dt.sortOrder = -1;

    // if (typeof dt.sort === 'function') {
    //   dt.sort({
    //     field: 'scJobId',
    //     order: -1
    //   });
    // }

    dt.first = 0;
    this.rowsPerPage = DEFAULT_ROWS_PER_PAGE;


    await this.getJobs();
  }

  async searchGlobal(dt: Table): Promise<void> {
    dt.first = 0;
    if (dt.onLazyLoad) {
      dt.onLazyLoad.emit({
        first: 0,
        rows: this.rowsPerPage,
        globalFilter: this.globalSearchValue,
        filters: {},
        sortField: dt.sortField,
        sortOrder: dt.sortOrder,
      });
    }
  }
  
    
  async getJobs(): Promise<void> {
    try {
      Loading.standard('getjobs: Loading Job List...');
      this.currentUser = await this.authService.userAuth();

      this.currentUserRoleName = this.users.getRoleName(
        this.currentUser.roles[0]
      );
      this.currentUserPrimaryRole = this.currentUser.roles[0];

      this.specificJobStatusShowing = undefined; // Reset specific job status showing

      //required for firstload [lazyLoadOnInit]="true" seems not to work
      let event: TableLazyLoadEvent;

        event = {
          first: 0,
          rows: this.rowsPerPage,
          globalFilter: '',
          filters: {},
          sortField: 'scJobId',
          sortOrder: -1,
        };

      await this.loadJobsLazy(event);

      if (this.jobs.length > 0) {
        Loading.remove();
        // const activeJobRequests = await this.jobsService.getActiveJobRequests()
        // const prismaJobRequests = activeJobRequests;
      }
    } catch (error: any) {
        console.log(error);
    } finally {
      Loading.remove();
    }
  }

  async loadJobsLazy(event: TableLazyLoadEvent): Promise<void> {
    
    if (this.isLoading || event.first == null || event.rows == null || event.rows == 0) return;

    this.lastLazyEvent = { ...event };

    console.log('lazyevent', event);
    
    const filterParams: jobsFilterTypes = {
      globalFilter: event.globalFilter,
      filters: event.filters,
      sortField: event.sortField || 'scJobId',
      sortOrder: event.sortOrder || -1,
    };

    // if filters or page size changed, reset the loaded chunks and jobs array
    const currentFiltersState = JSON.stringify(filterParams) + this.specificJobStatusShowing + event.rows;
    this.currentFilters = filterParams;
    if (currentFiltersState !== this.previousFiltersState) {
      this.previousFiltersState = currentFiltersState;
      this.loadedChunks.clear();
      event.first = 0;
     
      const response = await this.jobsService.getJobsStatusCount(
        this.currentUser,
        filterParams,
        this.specificJobStatusShowing 
      );

      if (response.data && response.data.length > 0) {
        console.log('Status totals from query filter:', response.data);
        this.statusTotals = this.getStatusesFromQueryFilter(response.data);
      }

      this.jobs = Array(this.totalRecords).fill(undefined);
      console.log('Filters or page size changed, resetting loaded chunks and jobs array, total records:', this.totalRecords);
    }
   
    const chunksize = event.rows;
    const chunkNumber = Math.floor(event.first / chunksize);

    if (this.loadedChunks.has(chunkNumber)) return;

    this.isLoading = true;

    try {
      await this.loadChunk(chunkNumber, chunksize, filterParams);
      
      // Preload next chunk only if there are more records to load
      if ((chunkNumber + 1) * chunksize < this.totalRecords) {
        this.loadChunk(chunkNumber + 1, chunksize, filterParams, false);
      }
    } finally {
      setTimeout(() => {
        this.isLoading = false;
      }, 300);

      if (this.jobs.length === 0) {
                this.messageService.add({
            severity: 'info',
            summary: 'No jobs match your search criteria',
            detail: 'Please try adjusting your filters or search terms'
          });
      }
    }

  }
    
  private async loadChunk(chunkNumber: number, chunkSize: number, filterParams: jobsFilterTypes, updateUI = true): Promise<void> {
    if (this.loadedChunks.has(chunkNumber)) return;

    console.log(`Loading chunk ${chunkNumber} with size ${chunkSize}`);
    
    const first = chunkNumber * chunkSize;
    
    try {
      const response = await this.jobsService.getJobs(
        this.currentUser,
        first,
        chunkSize,
        filterParams,
        this.specificJobStatusShowing 
      );
      
      // if the total changes, update the totalRecords and adjust rowsPerPage
      this.totalRecords = response.data[0]?.TotalCount || 0;
      if (this.totalRecords !== this.jobs.length) {
        this.jobs = Array(this.totalRecords).fill(undefined);
      }

      // Adjust rowsPerPage based on totalRecords
      if (this.totalRecords < this.rowsPerPage) {
        this.rowsPerPage = this.totalRecords;
      } else {
        this.rowsPerPage = DEFAULT_ROWS_PER_PAGE;
      }

      
      this.jobs.splice(first, response.data.length, ...response.data);

      console.log (response.data);

      // Mark this chunk as loaded
      this.loadedChunks.add(chunkNumber);
      
      if (updateUI) {
        // smooth update the UI
        this.cd.detach();
        this.jobs = [...this.jobs];
        Promise.resolve().then(() => {
          this.cd.reattach();
          this.cd.markForCheck();
        });
      }

    } catch (error) {
      console.error(`Error loading chunk ${chunkNumber}:`, error);
    }
  }
  
  
  //this function was changed to operate with scJobId instead of jobId and update the mongo job on the fly
  async getJob(scJobId: number): Promise<ISqlJob | undefined> {
    return this.jobsService.getMongoCompletionbyScJob(scJobId)
      .then(async (updatedJob) => {
        const jobIndex = this.jobs.findIndex(j => j.scJobId === updatedJob.scJobId);
        if (jobIndex > -1) {
          this.jobs[jobIndex] = updatedJob;
          this.statusTotals = await this.getDistinctStatusesAndTotals();
          this.jobs = [...this.jobs];
          this.cd.detectChanges();
        }
        return updatedJob;
      })
      .catch(e => {
        console.log(e);
        this.messageService.add({
          severity: 'error',
          summary: 'Unable to Load Job',
          detail: e.message ? e.message : 'An unknown error occurred.'
        });
        return undefined;
      });
  }

  copyToClipboard(email: string): void {
    if (!validateEmail(email)) {
      // You might want to show a toast message here
      return;
    }
    navigator.clipboard.writeText(email);
  }

  isValidEmail(email: string): boolean {
    return validateEmail(email);
  }

  formatEnumKey(key: string): string {
    try {
      const ACRONYMS = ['QC'];
      return key
        .split('_')
        .map(word => {
          if (ACRONYMS.includes(word)) {
            return word;
          } else {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          }
        })
        .join(' ');
    } catch (error) {
      console.error(`Unable to format enum key: ${key}.\nError: ${error}`);
      return 'Unknown';
    }
  }

  getJobStatusDropdownOptions(): any[] {
    return   Object.keys(JOB_STATUS)
    .filter(key => isNaN(Number(key)))
    .map(key => ({
      name: this.formatEnumKey(key),
      code: JOB_STATUS[key as keyof typeof JOB_STATUS]
    }));    
  }
  
  getJobStatusName(jobStatusId: JOB_STATUS): string {
    return this.formatEnumKey(Object.keys(JOB_STATUS).find(key => JOB_STATUS[key as keyof typeof JOB_STATUS] === jobStatusId)!);
  }

  showJobStatusPanel(jobStatusId: number, event: Event): void {
    this.selectedJobStatusId = jobStatusId;
  }

  async updateJobStatus(job: ISqlJob, overlaypanel: any): Promise<void> {
    if (!this.selectedJobStatusId || this.selectedJobStatusId === job.scJobStatusId) {
      this.messageService.add({
        severity: 'warn',
        summary: `The status for Job ${job.scJobId} was not changed`,
      });
      overlaypanel.toggle(false);
      return;
    }

    this.confirmationService.confirm({
      key: 'jobsManagerConfirmDialog',
      message: `Are you sure you want to update the status of Job ${job.scJobId} to "${this.getJobStatusName(this.selectedJobStatusId)}" status?`,
      accept: () => {
        const oldJobStatusId = job.scJobStatusId;
        const userName = `${this.currentUser?.userName|| 'Unkown'}`;
        job.scJobStatusId = this.selectedJobStatusId;
        overlaypanel.toggle(false);         
        // Loading.standard(`Updating Job Status for ${job.scJobId}...`);
        this.jobsService.updateJobStatusId(job.scJobId, this.selectedJobStatusId)
          .then(res => {
            // Loading.remove();
            this.messageService.add({
              severity: 'success',
              summary: `Status Update Successful`,
              detail: `Job ${job.scJobId} has been updated to "${this.getJobStatusName(this.selectedJobStatusId)}" status.`
            });
            this.notesService.createScJobNote(job.scJobId,
              `Status changed from [ ${this.getJobStatusName(oldJobStatusId).toUpperCase()} ] to [ ${this.getJobStatusName(res.JobStatusId).toUpperCase()} ] by ${userName}.`, true)
              .catch(e => console.error(`Unable to save note for inspection status change.\n${e}`));
            this.getJob(job.scJobId);
          })
          .catch(e => {
            console.log(`Unable to update job status to ${this.getJobStatusName(this.selectedJobStatusId)}.\n${e.message? e.message : 'An unknown error occurred.'});`);
            // Loading.remove();
            this.messageService.add({
              severity: 'error',
              summary: 'Status Update Failed',
              detail: `Unable to update job ${job.scJobId} to "${this.getJobStatusName(this.selectedJobStatusId)}" status.`,
            });
          })
          .finally(() => {
            this.selectedJobStatusId = 0;
          });
      },
      reject: () => {
        this.selectedJobStatusId = 0;
        overlaypanel.toggle(false);
      }
    });
  }

  //TODO this function is used to show specific job status jobs when the user has the button on the bottom of the page
  //once we are sure that the flow with the regular filter is ok, we can remove this function and remove also the funcionality on the backend
  async showSpecificJobStatus(jobStatus: JOB_STATUS, resetFilters: boolean = true): Promise<void> {
    try {
      console.log(`Showing jobs with status: ${this.getJobStatusName(jobStatus)}`);
      this.specificJobStatusShowing = jobStatus;

      if (resetFilters && this.dataTable) {
        this.dataTable.reset(); 
        this.cd.detectChanges();
      }

      let event: TableLazyLoadEvent;
      if (!resetFilters && this.lastLazyEvent) {
        event = { ...this.lastLazyEvent };
      } else {
        event = {
          first: 0,
          rows: this.rowsPerPage,
          globalFilter: '',
          filters: {},
          sortField: 'RequestDate',
          sortOrder: -1,
        };
      }
      Loading.standard(`Getting ${this.getJobStatusName(jobStatus)} Jobs...`);

      await this.loadJobsLazy(event);

    } catch (error) {
      console.log(`Unable to get ${this.getJobStatusName(jobStatus)} jobs.\nError: ${error}`);
    } finally {
      Loading.remove();
    }
  }


  canShowInspectionFormButton(job: ISqlJob): boolean {
    if (this.currentUserPrimaryRole !== UserRole.REP && this.currentUserPrimaryRole !== UserRole.GUEST) {
      return true;
    } else if ((this.currentUserPrimaryRole === UserRole.REP || this.currentUserPrimaryRole === UserRole.GUEST) && (job.scJobStatusId !== JOB_STATUS.QC && job.scJobStatusId !== JOB_STATUS.ON_HOLD && job.scJobStatusId !== JOB_STATUS.INSURED)) {
      return true;
    } else {
      return false;
    }
  }

  openPdfFormDialog(event: any): void { 
    if (!event?.shiftKey) {
      this.ref = this.dialogService.open(PdfFormComponent, { 
        data: { url: '' },
        header: 'PDF Form',
        footer: ` `,
        width: '50vw',
        height: '75vh',
        closable: true,
        closeOnEscape: true,
        modal: true,
      });
  
      this.ref.onClose.subscribe((response) => {
  
      });
    }
  }

  
  formatStatusTimestamp(isoString: string | undefined | null): string {
    if (!isoString) return '';
    return this.datePipe.transform(isoString, 'MM/dd/yyyy, hh:mm a' ) || '';
  }
}
